import React, { ForwardedRef, forwardRef } from 'react';
import { StackProps } from 'src/app/atoms/Layout/Stack/Stack';
import { FillSpaceContainer } from './FillSpace.styles';

export interface FillSpaceProps extends StackProps {
  height?: string | number;
}

const FillSpace = (
  { height, ...stackProps }: FillSpaceProps,
  forwardedRef: ForwardedRef<HTMLDivElement>
): JSX.Element => {
  return (
    <FillSpaceContainer
      ref={forwardedRef}
      $height={height}
      {...stackProps}
    />
  );
};

export default forwardRef(FillSpace);
